import { selectDiffLines } from '../lib/utils/diff_utils';
import SuggestionDiffHeader from './suggestion_diff_header.vue?vue3';
import SuggestionDiffRow from './suggestion_diff_row.vue';
export default {
    name: 'SuggestionDiff',
    components: {
        SuggestionDiffHeader,
        SuggestionDiffRow
    },
    props: {
        suggestion: {
            type: Object,
            required: true
        },
        batchSuggestionsInfo: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        helpPagePath: {
            type: String,
            required: true
        },
        defaultCommitMessage: {
            type: String,
            required: true
        },
        suggestionsCount: {
            type: Number,
            required: false,
            default: 0
        },
        failedToLoadMetadata: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'add-to-batch',
        'apply',
        'apply-batch',
        'remove-from-batch'
    ],
    computed: {
        batchSuggestionsCount () {
            return this.batchSuggestionsInfo.length;
        },
        isBatched () {
            return Boolean(this.batchSuggestionsInfo.find(({ suggestionId })=>suggestionId === this.suggestion.id));
        },
        lines () {
            return selectDiffLines(this.suggestion.diff_lines);
        }
    },
    methods: {
        applySuggestion (callback, message) {
            this.$emit('apply', {
                suggestionId: this.suggestion.id,
                callback,
                message
            });
        },
        applySuggestionBatch (message) {
            this.$emit('apply-batch', message);
        },
        addSuggestionToBatch () {
            this.$emit('add-to-batch', this.suggestion.id);
        },
        removeSuggestionFromBatch () {
            this.$emit('remove-from-batch', this.suggestion.id);
        }
    }
};
